<template>
  <ValidationProvider :rules="rules" v-slot="{ errors, valid }" :name="errorLabelText">
    <b-field :label="label" :type="{'is-danger': errors.length }" :message="errors[0]">
      <vue-tel-input
        class="input"
        :wrapper-classes="'phoneinputwrapper'"
        :input-classes="'phoneinput'"
        v-model="data"
        :enabled-country-code="false"
        :name="name"
        @onInput="handleInput"
        @onValidate="handleValidation"
      ></vue-tel-input>
    </b-field>
  </ValidationProvider>
</template>

<script>
import VueTelInput from "vue-tel-input";
import { ValidationProvider } from "vee-validate";

export default {
  name: "PhoneNumberInput",

  props: {
    rules: { type: String, required: true },
    model: { type: String | Boolean },
    label: { type: String, default: "" },
    vuexKey: { type: String, required: true },
    name: { type: String, required: true },
    errorLabel: { type: String },
  },

  components: {
    VueTelInput,
    ValidationProvider
  },

  data() {
    return {
      data: this.model
    };
  },

  computed: {
    /**
     * Determine the text to be used as the field name when displaying error messages
     */
    errorLabelText() {
      if (this.errorLabel) {
        return this.errorLabel;
      }

      return this.name;
    }
  },

  methods: {
    handleInput: function({ number, isValid, country }) {
      this.$emit("input", { key: this.vuexKey, value: number });
    },

    handleValidation: function({ number, isValid, country }) {}
  }
};
</script>

<style lang="scss" scoped>
.phoneinputwrapper {
  border: 1px solid #dbdbdb !important;
}
input.phoneinput {
  font-size: 15px !important;
}
</style>
